import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ShipmentLoadTrackingMapLoad, ShipmentLoadTrackingMapInitialState } from './shipment-load-tracking-map.actions';
import { ShipmentLoadTrackingMapService } from './shipment-load-tracking-map.service';
import { Injectable } from '@angular/core';
import { ShipmentLoadMapData } from '../../models/shipment-load-tracking-map.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ShipmentLoadToGpsPointModel } from '../../../../models';

export interface ShipmentLoadTrackingMapStateModel {
  mapData: ShipmentLoadMapData;
  loaded: boolean;
}

const initialState: ShipmentLoadTrackingMapStateModel = {
  mapData: null,
  loaded: false,
};

@State<ShipmentLoadTrackingMapStateModel>({
  name: 'shipmentLoadTrackingMapData',
  defaults: initialState,
})
@Injectable()
export class ShipmentLoadTrackingMapState {
  @Selector()
  static getState(state: ShipmentLoadTrackingMapStateModel): ShipmentLoadTrackingMapStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentLoadTrackingMapStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getMapData(state: ShipmentLoadTrackingMapStateModel): ShipmentLoadMapData {
    return state.mapData;
  }

  constructor(
    private shipmentLoadTrackingMapService: ShipmentLoadTrackingMapService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentLoadTrackingMapLoad)
  getWaybillTrackingMapData(
    ctx: StateContext<ShipmentLoadTrackingMapStateModel>,
    { payload }: ShipmentLoadTrackingMapLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentLoadTrackingMapService.getShipmentLoadTrackingMapData(payload).pipe(
      map((mapData: ShipmentLoadMapData) => {
        const gpsPoints = mapData.gpsPoints.map((point: ShipmentLoadToGpsPointModel, index: number) => {
          point.sortIndex = `${index}`;
          return point;
        });
        ctx.patchState({
          mapData: { gpsPoints, points: mapData.points, stops: mapData.stops, transportMode: mapData.transportMode },
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentLoadTrackingMapInitialState)
  setInitialState(ctx: StateContext<ShipmentLoadTrackingMapStateModel>): void {
    ctx.setState(initialState);
  }
}
